<template>
  <v-container>
    <page-title title="今日價格" />
    <formPlugin :form-key="formKey" :component="formContent"></formPlugin>
    <eagle-form :form-key="formKey"> </eagle-form>
  </v-container>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './providerTodayPrice'
import formPlugin from "@/components/eaglePlugin/formPlugin.vue"

export default {
  mixins: [formMixin],
  components: {
    formPlugin
  },

  data: () => ({
    formKey: 'provider-today-price-form',
    meta: {},
  }),

  computed: {
    formContent() {
      return () => import('@/modules/provider/views/priceCard/pricePivot.vue')
    },
    providerId() {
      return this.$store.getters[`member/providerId`]
    },
    memberId() {
      return this.$store.getters[`token/memberId`]
    },
  },
  methods: {
    async beforeFormInit() {
      await Promise.all([])
    },
    validateBeforeSave() {
      // TODO
    },
    afterSaveSuccessCallback(result) {

    },
    async readApi(target) {
      const res = await this.$api.collection.providerApi.getTodayProducts(
        this.providerId
      );
      return res.data;
    },
    async updateApi(target, formData) {
      let send = [];
      send = formData.map((item) => {
        return {
          product_id: item.id,
          price: item.price,
          discount_config: [
            {
              max: 0,
              min: 0,
              price: 0,
            },
          ],
        };
      });

      console.log('updateApi - send :', send);
      await this.$api.collection.providerApi.setTodayProductPrice(
        this.providerId,
        { items: send }
      );
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
